import { ActionReducerMap } from '@ngrx/store';

import * as fromUser from './init-user';
import * as fromSearchQuery from './search-query';

export interface State {
  user: fromUser.UserState;
  // app_settings: fromAppSettings.AppSettingState;
  search_query: fromSearchQuery.SearchQueryState;
}

export const reducers: ActionReducerMap<State> = {
  user: fromUser.reducer,
  // app_settings: fromAppSettings.reducer,
  search_query: fromSearchQuery.reducer,
};

export const effects = [
  fromUser.InitUserEffects,
  // fromAppSettings.AppSettingsEffects,
];
